import React from "react";

export default function PrivacyPolicyPage() {
  return (
    <div className="max-w-5xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">
        Privacy Policy
      </h1>

      <p className="mb-3">
        Welcome to Edu9. Your privacy is important to us.
      </p>

      <h2 className="text-xl font-semibold mt-4">
        Information We Collect
      </h2>
      <p>
        We may collect your name, phone number, email and
        educational details when you submit enquiry forms.
      </p>

      <h2 className="text-xl font-semibold mt-4">
        How We Use Information
      </h2>
      <p>
        We use your data to provide career counselling
        and admission guidance services.
      </p>

      <h2 className="text-xl font-semibold mt-4">
        Contact Us
      </h2>
      <p>
        If you have any questions contact us at edu9.in
      </p>
    </div>
  );
}
